module.exports = __webpack_public_path__ + "static/media/fullscreen_exit.8317d19e.svg";